import { Trans, useTranslations } from "adapters/i18n";
import ConfirmationModal from "features/shared/components/confirmationModal";
import React from "react";
import history from "../../../app/History";

const ModalPastureRegistration = ({ classes, setIsModalShown }) => {
  const { t } = useTranslations();

  const navigateToRegisterPasture = () => {
    const registerPath = "/cadastro";
    setIsModalShown(false);
    history.push(registerPath);
  };

  return (
    <ConfirmationModal
      classNames={{
        buttonsContainer: classes.buttonsContainer,
        customClass: classes.customClass,
        submitButtonClass: classes.submitButtonClass,
        cancelButtonClass: classes.cancelButtonClass,
      }}
      title={
        <span className={classes.modalTitle}>
          {t("errors:no-registered-pastures.title")}
        </span>
      }
      text={
        <span className={classes.modalText}>
          <Trans
            i18nKey="errors:no-registered-pastures.description"
            components={{
              highlight: <span className={classes.modalTextInfo} />,
            }}
          />
        </span>
      }
      submitButtonTitle={t("locales:register-pasture")}
      cancelButtonTitle={t("common:actions.close")}
      onSubmit={navigateToRegisterPasture}
      onCancel={setIsModalShown}
      onClose={setIsModalShown}
    />
  );
};

export default ModalPastureRegistration;
